// extracted by mini-css-extract-plugin
export default {"cont":"FileLoader_cont__L9kVw","file":"FileLoader_file__kW5KP","fileReaderButton":"FileLoader_fileReaderButton__0Ku9C","fileName":"FileLoader_fileName__7XZI-"};